export const TackePrimjeneResourcesEN: TackePrimjeneResourcesBSInterface = {
  dupplicateError: "Addition failed, entered data is duplicated",
  odabirKompanije: {
    title: "Evidence points",
    dropdownLabel: "Select company:",
    dropdownPlaceholder: "Select company",
    dropdownNoOptionsMessage: "No companies entered",
    addCompanyButton: "Add company",
    next: "Select",
    back: "Back",
    errorLoading: "Error during loading. Please contact the administrator.",
  },
  odabirPoslovnice: {
    title: "Evidence points",
    dropdownLabel: "Select branch:",
    dropdownPlaceholder: "Select branch",
    dropdownNoOptionsMessage: "No branches entered",
    addCompanyButton: "Add branch",
    next: "Edit",
    back: "Back",
    errorLoading: "Error during loading. Please contact the administrator.",
  },
  izmjenaTP: {
    title: "Edit AP",
    recordpointtreesError: "Enter Record Point JSON",
    recordpointtreesLabel: "Enter evidence points",
    loadTemplateButton: "Add example",
    recordpointtreesName: "recordpointtrees",
    successModal: {
      title: "Data Entry",
      body: "Data addition has been successfully completed. Select OK to continue.",
      buttonOk: "OK",
    },
    buttonTP: "Add evidence points",
    errorLoading: "Error during loading. Please contact the administrator.",
    errorUpdate: "Error during update. Please contact the administrator.",
  },
};

export interface TackePrimjeneResourcesBSInterface {
  dupplicateError: string;
  odabirKompanije: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
    errorLoading: string;
  };
  odabirPoslovnice: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
    errorLoading: string;
  };
  izmjenaTP: {
    title: string;
    recordpointtreesError: string;
    recordpointtreesLabel: string;
    loadTemplateButton: string;
    recordpointtreesName: string;
    successModal: {
      title: string;
      body: string;
      buttonOk: string;
    };
    buttonTP: string;
    errorLoading: string;
    errorUpdate: string;
  };
}

/*
Example json array: 
{
  "TackePrimjene": [
    {
      "NazivTacke": "Dvoriste",
      "Parent": "",
      "Order": "1"
    },
    {
      "NazivTacke": "Objekat",
      "Parent": "",
      "Order": "2"
    },
    {
      "NazivTacke": "Kancelarija",
      "Parent": "Objekat",
      "Order": "1"
    },
    {
      "NazivTacke": "WC",
      "Parent": "Objekat",
      "Order": "1"
    },
    {
      "NazivTacke": "Lavabo",
      "Parent": "WC",
      "Order": "1"
    },
    {
      "NazivTacke": "Cesma",
      "Parent": "Lavabo",
      "Order": "1"
    },
    {
      "NazivTacke": "Ogledalo",
      "Parent": "Lavabo",
      "Order": "2"
    }
  ]
}

*/
